<template>
  <div class="animated fadeIn">
    <b-alert :variant="dismissibleType"
             dismissible
             :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
      {{ errMsg }}
    </b-alert>
    <div>
      <b-card>
        <div slot="header">
          <strong>mGauge Vehicle Sets</strong>
        </div>
        <b-row>
          <b-col md="3" xl="2" class="m-0 p-0">
            <div style="height: 45vh; overflow: auto;border-bottom:1px solid #D3D3D3; " class="mb-3">
              <b-btn id="btnAddNewVehSet" variant="primary" class="w-100" @click="createVehicleSet">
                <i class="fa fa-plus-square text-white" title="Add a new vehicle set"></i> <strong class="text-white">Add a new vehicle set</strong>
              </b-btn>
              <b-list-group>
                <b-list-group-item :id="vs.id.toString()" v-for="vs in vehicleSets" button class="p-0"
                                   @click="editVehicleSet(vs.id)">
                  <div class="d-flex w-100 h-100" style="padding: 10px 10px 10px 20px;"
                       v-bind:class="[(vs.id === -1) ? 'alert-success' : '', (vs.id == activeVehicleSet.id) ? 'alert-primary': '']">
                    <span>{{ vs.title }}</span>
                  </div>
                </b-list-group-item>
                <b-list-group-item v-if="!vehicleSets.length" button class="d-flex justify-content-between align-items-center" style="padding: 5px 5px 5px 20px;">
                  <div class="d-flex">
                    <span>No sets created yet.</span>
                  </div>
                </b-list-group-item>
              </b-list-group>
            </div>
            <div style="height: 25vh; overflow: auto;border-bottom:1px solid #D3D3D3;">
              <b-list-group>
                <div class="form-control bg-primary text-center" style="font-weight: bold">
                  Archive
                </div>
                <b-list-group>
                  <b-list-group-item :id="vs.id.toString()" v-for="vs in vehicleSetsArchive" button class="p-0"
                                     @click="editVehicleSet(vs.id)">
                    <div class="d-flex w-100 h-100" style="padding: 10px 10px 10px 20px;"
                         v-bind:class="[(vs.id === -1) ? 'alert-success' : '', (vs.id == activeVehicleSet.id) ? 'alert-primary': '']">
                      <span>{{ vs.title }}</span>
                    </div>
                  </b-list-group-item>
                  <b-list-group-item v-if="!vehicleSets.length" button class="d-flex justify-content-between align-items-center" style="padding: 5px 5px 5px 20px;">
                    <div class="d-flex">
                      <span>No sets created yet.</span>
                    </div>
                  </b-list-group-item>
                </b-list-group>
              </b-list-group>
            </div>
          </b-col>
          <b-col class="col-lg-12 col-xl-9" v-if="initLoad">
            <div class="col-lg-7 offset-lg-2" style="text-align: center; height: 100%; opacity: 0.7; filter: alpha(opacity=70);">
              <div style="text-align: right; margin-top: calc(50vh - 250px);">
                <img src="/web/img/mgauge_logo.png" alt="mGuage Logo" class="img-fluid">
                <h4 style="margin-right: 2rem !important;">State of the Art Analysis for Lenders.</h4>
              </div>
            </div>
          </b-col>
          <b-col md="9" xl="10"  v-else>
            <div v-if="activeVehicleSet" class="m-0 p-0">
              <form class="validationForm" onsubmit="event.preventDefault(); return false;">
                <b-row class="d-flex m-0 p-1">
                  <label for="activeVehicleSet" class="mr-auto h4">{{activeVehicleSet.title}}</label>
                    <button id="btnSaveSet" class="btn btn-success mr-2" @click="saveVehicleSet" :disabled="(activeVehicleSet.id == -1)">
                      <i class="fa fa-save" title="Add a new vehicle set"></i> <strong class="text-white">Save Set</strong>
                    </button>
                    <button id="btnSaveSetAs" class="btn btn-success mr-2" v-b-modal.modal-prevent-closing>
                      <i class="fa fa-save" title="Add a new vehicle set"></i> <strong class="text-white">Save Set As</strong>
                    </button>
                    <button id="btnDelete" class="btn btn-danger text-white" @click="deleteVehicleSet" v-if="activeVehicleSet.isactive==true">
                      <i title="Delete" class="fa fa-trash-o fa-lg"></i> <strong class="text-white">Archive</strong>
                    </button>
                    <button id="btnUnDelete" class="btn btn-danger text-white" @click="undeleteVehicleSet" v-if="activeVehicleSet.isactive!= true && activeVehicleSet.id > 0">
                      <i title="UnDelete" class="fa fa-exchange fa-lg"></i> <strong class="text-white">Activate</strong>
                    </button>
                </b-row>
                <table aria-busy="false" aria-colcount="3" class="table b-table table-striped table-bordered table-sm">
                  <tbody>
                    <tr v-if="1 == 2" class="b-table-empty-row">
                      <td><div role="alert" aria-live="polite"><div class="text-center my-2">No vehicles added created yet.</div></div></td>
                    </tr>
                    <tr>
                      <b-row class="mt-4" >
                        <b-col lg="4">
                          <b-card>
                            <div slot="header">
                              <strong>Year</strong>
                              <em class="error invalid-feedback">{{ validateErrors.first('Year') }}</em>
                            </div>
                            <b-form-group :horizontal="true" class="m-0">
                              <b-form-radio-group id="activeVehicleSetisnew"
                                                  v-model="activeVehicleSet.isnew"
                                                  :plain="true"
                                                  :options="[{text: 'New',value: true},{text: 'Used',value: false}]"
                                                  :checked="activeVehicleSet.isnew"
                                                  @change="changeNewUsed(event,!activeVehicleSet.isnew)">
                              </b-form-radio-group>
                            </b-form-group>
                            <div style="padding:-10px 0 10px 0;">
                              <a id="btnSelectAllYear" href="javascript:void(0)" @click="selectallYears(true)">Select All</a> | <a id="btnUnselectAllYear" href="javascript:void(0)" @click="selectallYears(false)">Unselect All</a>
                            </div>
                            <div style="height: 60vh; overflow: auto">
                              <b-form-checkbox-group stacked :plain="false" v-model="activeVehicleSet.years"
                                                     :checked="activeVehicleSet.years"
                                                     v-validate="{required: true}"
                                                     name="Year"
                                                     v-bind:class="{'is-invalid': validateErrors.has('Year') }">
                                <b-form-checkbox :id="y.toString()" v-for="y in form_options.years" @change="selectYear($event, y)" :value="y" v-bind:key="y">
                                  {{ y }}
                                </b-form-checkbox>
                              </b-form-checkbox-group>
                            </div>
                          </b-card>
                        </b-col>
                        <b-col lg="4"  v-if="activeVehicleSet.years.length">
                          <b-card>
                            <div slot="header">
                              <strong>Make</strong>
                              <em class="error invalid-feedback">{{ validateErrors.first('Make') }}</em>
                            </div>
                            <a id="btnSelectAllMakes" href="javascript:void(0)" @click="selectallMakes(true)">Select All</a> | <a id="btnUnselectAllMakes" href="javascript:void(0)" @click="selectallMakes(false)">Unselect All</a>
                            <div style="height: 60vh; overflow: auto">
                              <b-form-checkbox-group stacked :plain="true"
                                                     v-model="activeVehicleSet.makes"
                                                     :checked="activeVehicleSet.makes"
                                                     v-validate="{required: true}"
                                                     name="Make"
                                                     v-bind:class="{'is-invalid': validateErrors.has('Make') }">
                                <b-form-checkbox :id="m.Name" v-for="m in sortArrays(form_options.makes)" :value="m"
                                                 @change="selectMake($event, m)"
                                                 v-bind:key="m.MakeID">
                                  {{ m.Name.replace('_',' ') }}
                                </b-form-checkbox>
                              </b-form-checkbox-group>

                            </div>
                          </b-card>
                        </b-col>
                        <b-col lg="4" v-if="activeVehicleSet.makes.length">
                          <b-card>
                            <div slot="header">
                              <strong>Model</strong>
                              <em class="error invalid-feedback">{{ validateErrors.first('Model') }}</em>
                            </div>
                            <div style="height: 62vh; overflow: auto">
                              <div v-for="make in activeVehicleSet.makes">
                                <strong>{{make.Name}}</strong><br />
                                <small><a id="btnSelectAllModel" href="javascript:void(0)" @click="selectallModels(true,make.MakeID)">Select All</a> | <a id="btnUnselectAllModel" href="javascript:void(0)" @click="selectallModels(false,make.MakeID)">Unselect All</a></small>
                                <b-form-checkbox-group stacked :plain="true"
                                                       v-model="activeVehicleSet.models"
                                                       :checked="activeVehicleSet.models"
                                                       v-validate="{required: true}"
                                                       name="Model"
                                                       v-bind:class="{'is-invalid': validateErrors.has('Model') }">
                                  <b-form-checkbox :id="m.Name" v-for="m in sortArrays(form_options.models)" v-if="m.MakeID == make.MakeID" :value="m"
                                                   v-bind:key="m.ModelID" @change="selectModel()">
                                    {{ m.Name.replace('_',' ') }}
                                  </b-form-checkbox>
                                </b-form-checkbox-group>
                              </div>
                            </div>
                          </b-card>
                        </b-col>
                        <b-col lg="3" hidden>
                          <b-card>
                            <div slot="header">
                              <strong>Trim</strong>
                            </div>
                            <a href="javascript:void(0)" @click="selectallModels(true)">Select All</a> | <a href="javascript:void(0)" @click="selectallModels(false)">Unselect All</a>
                            <div style="height: 200px; overflow: auto">
                              <b-form-checkbox-group stacked :plain="true" v-model="activeVehicleSet.trims"
                                                     :checked="activeVehicleSet.trims">
                                <b-form-checkbox v-for="t in form_options.trims" :value="t" v-bind:key="t">
                                  {{ t }}
                                </b-form-checkbox>
                              </b-form-checkbox-group>
                            </div>
                          </b-card>
                        </b-col>
                      </b-row>
                    </tr>
                  </tbody>
                </table>
              </form>
            </div>
            <div v-else>
              <table class="table b-table table-striped table-hover table-bordered table-sm">
                <tbody class="">
                  <tr class="b-table-empty-row"><td><div role="alert" aria-live="polite"><div class="text-center my-2">Select a vehicle set to edit.</div></div></td></tr>
                </tbody>
              </table>
            </div>
          </b-col>
        </b-row>

      </b-card>

      <b-modal id="modal-prevent-closing"
               ref="modal"
               title="Save Set As"
               @show="resetModal"
               @ok="handleOk">

        <form ref="form" class="validationForm" data-vv-scope="NewTitle" @submit.stop.prevent="handleSubmit">
          <label>Name</label><br />
          <b-form-input id="report-input"
                        v-model="new_title"
                        v-validate="{required: true}" :maxlength="250"
                        v-bind:class="{'is-invalid': validateErrors.has('NewTitle.Name') }" name="Name"
                        required></b-form-input>
          <em class="error invalid-feedback">{{ validateErrors.first('NewTitle.Name') }}</em>
        </form>
      </b-modal>
    </div>

    <loading :show="boolLoading"
             :label="txtLoading">
    </loading>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import loading from 'vue-full-loading'
import notify from 'devextreme/ui/notify'
import {Validator} from 'vee-validate'
import {confirm} from 'devextreme/ui/dialog'

export default {
  components: {
    loading
  },
  created () {
    this.loadVehicleSets()
    this.loadVehicleSetsArchive()
    axios.get('/api/mgauge/getvehicles')
      .then(response => {
        this.boolLoading = false
        this.availableNewVehicles = response.data["NewVehicles"]
        this.availableUsedVehicles = response.data["UsedVehicles"]
        this.vehicles = this.availableNewVehicles;
        this.form_options = this.availableNewOptions;
        this.form_options.years = _.uniq(_.map(this.vehicles, 'Year'))
        onsole.log("this.vehicles", this.vehicles);
      })
      .catch(error => {
        if (error.response.status === 403) { this.$router.push('/login') }
        this.boolLoading = false
        this.errMsg = 'There was an error getting data : ' + error
        this.showDismissibleAlert = true
      })
    this.initLoad = true
  },
  data () {
    return {
      errMsg: '',
      initLoad: true,
      changesSaved: true,
      dismissibleType: 'danger',
      showDismissibleAlert: false,
      boolLoading: false,
      txtLoading: 'Loading...',
      activeVehicleSet: { id: -1, title: '', isnew: true, years: [], makes: [], models: [], trims: [] },
      blankVehicleSet: { id: -1, title: '<Untitled>', isnew: true, years: [], makes: [], models: [], trims: [], isactive: true },
      availableNewOptions: { years: [], makes: [], models: [], trims: [] },
      availableUsedOptions: { years: [], makes: [], models: [], trims: [] },
      availableNewVehicles: [],
      availableUsedVehicles: [],
      vehicleSets: [],
      vehicleSetsArchive: [],
      new_title: '',
      vehicles: [],
      form_options: {}
    }
  },
    methods: {
    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault()
      if(this.new_title.length>0){
          this.handleSubmit()
      }
    },
    sortArrays(arrays) {
        return _.orderBy(arrays, 'Name', 'asc');
    },
    changeNewUsed(event,IsNew) {
      this.form_options.years = [];
      if (IsNew) {
        this.vehicles = this.availableNewVehicles;
        this.form_options = this.availableNewOptions;
      }
      else {
        this.vehicles = this.availableUsedVehicles;
        this.form_options = this.availableUsedOptions;
      }
      console.log("this.vehicles", this.vehicles);
      this.form_options.years = _.uniq(_.map(this.vehicles, 'Year'))
      var self = this
      var years = []
      self.activeVehicleSet.years = years
      var makes = []
      self.activeVehicleSet.makes = makes
      var models = []
      self.activeVehicleSet.models = models
    },
    handleSubmit() {
        if (!this.$refs.form.checkValidity()) {
          return
        }
      const found = this.vehicleSets.find(element => element.title.trim() === this.new_title.trim())
      if (found) {
        this.validateErrors.add({ 'field':'Name', 'scope':'NewTitle', 'msg': 'Name is not unique' });
        return
      }
      this.activeVehicleSet.id=-1;
      this.activeVehicleSet.title = this.new_title.trim();
      this.new_title="";
      this.saveVehicleSet();
      this.$nextTick(() => {
        this.$refs.modal.hide()
      })

    },
    resetModal() {
        this.new_title = 'Copy - ' + this.activeVehicleSet.title
     },
      selectYear(event, year) {
        this.changesSaved = false
      var SelectedModels = this.activeVehicleSet.models.filter(x => x);
      this.activeVehicleSet.models = [];
      var SelectedMakes = this.activeVehicleSet.makes.filter(x=>x);
      this.activeVehicleSet.makes = [];
      setTimeout(() => {
        var vMakes = this.GetMakesByYears(this.vehicles, this.activeVehicleSet.years);
        
        this.form_options.makes = _.uniqBy(_.map(vMakes, 'Make'), 'MakeID').sort();

        var CoincidenceMakes = this.form_options.makes.filter(x => this.IsMakeInMakes(SelectedMakes, x.MakeID));
        if (CoincidenceMakes.length > 0)
          this.activeVehicleSet.makes = CoincidenceMakes;
        var ModelsForThoseMakes = _.uniqBy(_.map(this.GetModelByMakesAndYears(this.vehicles, this.activeVehicleSet.years, CoincidenceMakes), 'Model'), 'ModelID')
        this.form_options.models = ModelsForThoseMakes;
        var concidenceModels = this.form_options.models.filter(x => this.IsModelInModels(SelectedModels, x.ModelID));
        if (concidenceModels.length > 0)
          this.activeVehicleSet.models = concidenceModels;
      }, 100);      
    },
      selectMake(event, make) {
        this.changesSaved = false
        var SelectedModels = this.activeVehicleSet.models.filter(x => x);
        setTimeout(() => {
          this.activeVehicleSet.models = [];
          this.selectModelsByMakes(this.vehicles, this.activeVehicleSet.makes)
          var concidenceModels = this.form_options.models.filter(x => this.IsModelInModels(SelectedModels, x.ModelID));
          if (concidenceModels.length > 0)
            this.activeVehicleSet.models = concidenceModels;
          this.selectallModels(true, make.MakeID);
        }, 100);
      },
      selectModel() {
        this.changesSaved = false
      },
    SwitchNewUsedElements() {
        if (this.activeVehicleSet.isnew) {
          this.vehicles = this.availableNewVehicles;
          this.form_options = this.availableNewOptions;
        }
        else {
          this.vehicles = this.availableUsedVehicles;
          this.form_options = this.availableUsedOptions;
        }
        this.form_options.years = _.uniq(_.map(this.vehicles, 'Year'))
    },
    unique(value, index, self) {
      return self.indexOf(value) === index
    },
    orderDesc(a, b) {
      return a < b
    },
    uniqueModel(value, index, self){
      var idxFound = -1;
      for (var idx = 0; idx < self.length; idx++) {
        if (self[idx].Model.Name == value.Model.Name) {
          return idx === index;
        }
      }
      return false;
    },
    orderByYearMakeModel(a, b) {
      var model_a = a.Year + "_" + a.Make.Name + "_" + a.Model.Name;
      var model_b = b.Year + "_" + b.Make.Name + "_" + b.Model.Name;
      if (model_a < model_b)
        return -1;
      if (model_a > model_b)
        return 1;
      return 0;
    },
    orderByYearMakeModelDesc(a, b){
      var model_a = a.Year + "_" + a.Make.Name + "_" + a.Model.Name;
      var model_b = b.Year + "_" + b.Make.Name + "_" + b.Model.Name;
      if (model_a > model_b)
        return -1;
      if (model_a < model_b)
        return 1;
      return 0;
    },
    GetMakesByYears(Vehicles, Years) {
      const res = Vehicles.filter(x => Years.includes(x.Year))
        .filter(this.unique).sort();
      return res;
    },
    GetModelByMakesAndYears(Vehicles, Years, Makes) {
      const res = Vehicles.filter(x => Years.includes(x.Year))
      .filter(x => this.IsMakeInMakes(Makes,x.Make.MakeID))
        .filter(this.uniqueModel).sort(this.orderByYearMakeModel);

      return res;
    },
    selectallMakes (SelectAll) {
      let self = this
      self.changesSaved = false
      var list = []
      self.activeVehicleSet.makes = list
      if (!SelectAll) { self.activeVehicleSet.models = [] }
      if (SelectAll) {
       
          self.form_options.makes.forEach(function (i) {
            list.push(i)
          })
        
        var SelectedModels = this.activeVehicleSet.models.filter(x => x);
        setTimeout(() => {
          this.activeVehicleSet.models = [];
          this.selectModelsByMakesSelected(this.vehicles, list)        
        }, 100);
      }
    },
    selectallModels (SelectAll, makeID) {
      let self = this
      self.changesSaved = false
      var list = []
      self.activeVehicleSet.models.filter(m => m.MakeID !== makeID).forEach(function (i) {
        list.push(i)
      })
      this.activeVehicleSet.models = list
      if (SelectAll) {
        if(self.activeVehicleSet.isnew){
          self.form_options.models.filter(m => m.MakeID === makeID).forEach(function (i) {
            list.push(i)
          })
        } else {
          self.form_options.models.filter(m => m.MakeID === makeID).forEach(function (i) {
            list.push(i)
          })
        }
      }
     },
     selectModelsByMakes(Vehicles, Makes) {
       var Models= this.GetModelByMakesAndYears(Vehicles, this.activeVehicleSet.years, Makes);
       this.form_options.models = _.uniqBy(_.map(Models, 'Model'), 'ModelID')
       this.form_options.models = this.form_options.models.sort();
      },
      selectModelsByMakesSelected(Vehicles, Makes) {
        var Models = this.GetModelByMakesAndYears(Vehicles, this.activeVehicleSet.years, Makes);
        this.form_options.models = _.uniqBy(_.map(Models, 'Model'), 'ModelID')
        this.form_options.models = this.form_options.models.sort();
        this.activeVehicleSet.models = this.form_options.models;
      },
      IsMakeInMakes(Makes,MakeID) {
        return Makes.filter(x => x.MakeID == MakeID).length>0;
      },
      IsModelInModels(Models, ModelID) {
        return Models.filter(x => x.ModelID == ModelID).length > 0;
      },

    selectallYears (SelectAll) {
      let self = this
      self.changesSaved = false
      var list = []
      self.activeVehicleSet.years = list
      if (SelectAll) {
        if (self.activeVehicleSet.isnew) {
          self.form_options.years.forEach(function (i) {
            list.push(i)
          })
        } else {
          self.form_options.years.forEach(function (i) {
            list.push(i)
          })
        }
        var SelectedModels = this.activeVehicleSet.models.filter(x => x);
        this.activeVehicleSet.models = [];
        var SelectedMakes = this.activeVehicleSet.makes.filter(x => x);
        this.activeVehicleSet.makes = [];
        setTimeout(() => {
          var vMakes = this.GetMakesByYears(this.vehicles, list);
          this.form_options.makes = _.uniqBy(_.map(vMakes, 'Make'), 'MakeID').sort();
          var CoincidenceMakes = this.form_options.makes.filter(x => this.IsMakeInMakes(SelectedMakes, x.MakeID));
          if (CoincidenceMakes.length > 0)
            this.activeVehicleSet.makes = CoincidenceMakes;
          var ModelsForThoseMakes = _.uniqBy(_.map(this.GetModelByMakesAndYears(this.vehicles, this.activeVehicleSet.years, CoincidenceMakes), 'Model'), 'ModelID')
          this.form_options.models = ModelsForThoseMakes;
          var concidenceModels = this.form_options.models.filter(x => this.IsModelInModels(SelectedModels, x.ModelID));
          if (concidenceModels.length > 0)
            this.activeVehicleSet.models = concidenceModels;
        }, 100);
      }
      else {
        self.activeVehicleSet.years = [];
        this.activeVehicleSet.makes = [];
        this.activeVehicleSet.models = [];

      }
    },
    loadVehicleSets () {
      axios.get('/api/mgauge/loadvehiclesets')
        .then(response => {
          this.boolLoading = false
          this.vehicleSets = response.data.data
          
        })
        .catch(error => {
          if (error.response.status === 403) { this.$router.push('/login') }

          this.boolLoading = false
          this.errMsg = 'There was an error getting data : ' + error
          this.showDismissibleAlert = true
        })
    },
    loadVehicleSetsArchive() {
        axios.get('/api/mgauge/loadvehiclesetsarchive')
          .then(response => {
            this.boolLoading = false
            this.vehicleSetsArchive = response.data.data

          })
          .catch(error => {
            if (error.response.status === 403) { this.$router.push('/login') }

            this.boolLoading = false
            this.errMsg = 'There was an error getting data : ' + error
            this.showDismissibleAlert = true
          })
      },
    createVehicleSet() {
      if (this.vehicleSets.some(x => x.id == -1)) {
        alert("You must save your current untitled set before creating a new one.")
        return
      }
      this.activeVehicleSet = JSON.parse(JSON.stringify(this.blankVehicleSet))
      this.vehicleSets.push(this.activeVehicleSet)
      this.SwitchNewUsedElements()
      this.initLoad = false
      this.changesSaved = false
      this.$nextTick(() => {
        this.errors.clear();
        this.$nextTick(() => {
          this.$validator.reset();
        });
      });   
    },
    editVehicleSet (setId) {
      this.initLoad = false
      if (this.changesSaved == false) {
        var result = confirm('You have unsaved changes to this set, are you sure you want to proceed?')
        result.then((dialogResult) => {
          if (!dialogResult) {
            return
          } else {
            this.completeChange(setId)
          }
        })
      }
      else {
        this.completeChange(setId)
      }
     
    },
      completeChange(setId) {
        var self =this
        var obj = {}
        obj.id = setId

        self.vehicleSets = self.vehicleSets.filter(x => x.id > 0)

        axios.post('/api/mgauge/loadvehicleset', obj)
          .then(response => {
            self.boolLoading = false
            self.activeVehicleSet = JSON.parse(JSON.stringify(response.data));
            var models = self.activeVehicleSet.models;
            self.SwitchNewUsedElements();
            setTimeout(() => {
              self.activeVehicleSet.models = models;
              if (self.activeVehicleSet.years.length > 0) {
                self.selectYear(event, self.activeVehicleSet.years[0]);
              }
              self.changesSaved = true
            }, 200);
          })
          .catch(error => {
            if (error.response.status === 403) { self.$router.push('/login') }
            self.boolLoading = false
            self.errMsg = 'There was an error getting data : ' + error
            self.showDismissibleAlert = true
          })
      },
    saveVehicleSet () {
      var self = this

      const found = self.vehicleSets.find(element => element.title.trim() === self.activeVehicleSet.title.trim() && Number(element.id) !== self.activeVehicleSet.id)
      if (found) {
        self.validateErrors.add({ 'field':'Name', 'scope':null, 'msg': 'Name is not unique' });
        return
      }

      self.$validator.validateAll().then((result) => {

        if (result) {
          axios.post('/api/mgauge/savevehicleset', this.activeVehicleSet)
            .then(response => {
              this.boolLoading = false
              this.activeVehicleSet = response.data
              this.loadVehicleSets()
              this.loadVehicleSetsArchive()
              this.changesSaved = true
              notify('Vehicle Set has been saved', 'success', 3500)
            })
            .catch(error => {
              if (error.response.status === 403) { this.$router.push('/login') }
              console.log(error.response)
              this.boolLoading = false
              this.errMsg = 'There was an error saving: ' + error.response.statusText
              this.showDismissibleAlert = true
              notify('Error saving vehicle set', 'error', 3500)
            })
        }
      })
    },
    undeleteVehicleSet() {
      let result = confirm('Are you sure?', 'Confirmation')
      result.then((dialogResult) => {
        if (dialogResult) {
          axios.post('/api/mgauge/undeletevehicleset', this.activeVehicleSet)
            .then(response => {
              this.boolLoading = false
              this.loadVehicleSets()
              this.loadVehicleSetsArchive()
              this.initLoad = true
              notify('Vehicle Set has been activated', 'success', 3500)
            })
            .catch(error => {
              if (error.response.status === 403) { this.$router.push('/login') }

              this.boolLoading = false
              this.errMsg = 'There was an error getting data : ' + error
              this.showDismissibleAlert = true

              if (error.response.status === 412) {
                this.errMsg = 'Delete failed : ' + error.response.statusText
              }

            })
        }
      })
    },
    deleteVehicleSet () {
      let result = confirm('Are you sure?', 'Confirmation')
      result.then((dialogResult) => {
        if (dialogResult) {
          axios.post('/api/mgauge/deletevehicleset', this.activeVehicleSet)
            .then(response => {
              this.boolLoading = false
              this.loadVehicleSets()
              this.loadVehicleSetsArchive()
              this.initLoad = true
              notify('Vehicle Set has been achived', 'success', 3500)
            })
            .catch(error => {
              if (error.response.status === 403) { this.$router.push('/login') }

              this.boolLoading = false
              this.errMsg = 'There was an error getting data : ' + error
              this.showDismissibleAlert = true

              if (error.response.status === 412) {
                this.errMsg = 'Delete failed : The vehicle set is being used' //+ error.response.statusText
              }

            })
        }
      })
    }
  },
  beforeRouteLeave (to, from, next) {
    if (!this.changesSaved) {
      let result = confirm('You have unsaved changes. Would you like to proceed and discard?', 'Warning')
      result.then((dialogResult) => {
        if (!dialogResult) {
          return next(false)
        } else {
          return next()
        }
      })
    }
    else {
       return next()
    }
  },
  mounted () {
    // boolLoading must be set to false on data() binding so that mount hooks the change
    this.boolLoading = false
  }
}
</script>

<style scoped>
  .table > tbody > tr > td {
    /*vertical-align: middle;*/
  }

  .table-xtra-condensed > thead > tr > th,
  .table-xtra-condensed > tbody > tr > th,
  .table-xtra-condensed > tfoot > tr > th,
  .table-xtra-condensed > thead > tr > td,
  .table-xtra-condensed > tbody > tr > td,
  .table-xtra-condensed > tfoot > tr > td {
    padding: 2px;
    text-align: center;
  }

  .h4 {
    margin-bottom: -5.5rem;
  }
</style>



// WEBPACK FOOTER //
// src/views/mGaugeVehicleSets.vue